<template>
    <div class="bg-primary-5 border rounded-4 p-24">
        <div :class="{'flex-col': compact}" class="flex justify-between items-center">
            <div :class="{'w-full': compact}" class="flex items-center">
                <business-avatar
                    class="flex-none bg-primary text-white"
                    icon="multiposting"
                />
                <div class="max-w-480 ml-24">
                    <p class="text-heading-1 font-semibold">{{ title }}</p>
                    <p>{{ description }}</p>
                </div>
            </div>
            <div :class="{'self-end mt-12': compact}" class="inline-flex gap-4 flex-wrap flex-col-reverse items-end xl:flex-row">
                <simple-button
                    :icon="collapseDiscover ? 'keyboard-arrow-up' : 'keyboard-arrow-down'"
                    @click="collapseDiscover = !collapseDiscover"
                >
                    {{ $t('general.discover') }}
                </simple-button>

                <simple-button
                    class="text-nowrap"
                    look="primary"
                    @click="goToIntegration"
                >
                    {{ $t('multi-posting.get_started') }}
                </simple-button>
            </div>
        </div>
        <div v-if="collapseDiscover" class="flex flex-col justify-center items-center">
            <div class="w-4/5 border-t my-32"></div>
            <MultiPostingCollapse
                class="max-w-960"
                hideBorder
                hideActivateButton
            />
        </div>
    </div>
</template>
<script>
import SimpleButton from "../ui/SimpleButton.vue";
import MultiPostingCollapse from "./MultiPostingCollapse.vue";
import BusinessAvatar from "../ui/BusinessAvatar.vue";

export default {
    name: 'MultiPostingDiscoverListItem',
    components: {BusinessAvatar, SimpleButton, MultiPostingCollapse},
    props: {
        title: {
            type: String,
            default: 'Dummy title',
        },
        description: {
            type: String,
            default: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Maxime minima odit perspiciatis qui saepe tenetur. Consectetur dignissimos, distinctio eaque ipsum molestiae molestias nihil pariatur quaerat reiciendis repellendus similique tempora ut?',
        },
        compact: Boolean,
    },
    data() {
        return {
            collapseDiscover: false,
        }
    },
    methods: {
        goToIntegration() {
            this.$router.push({ name: 'settings.integrations' })
        }
    },
}
</script>